import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { InvestmentState } from "@/domain/investment/types";
import type { InvestorSummary } from "@/domain/investor";

export interface CreateInvestmentRequest {
  state?: InvestmentState;
  investor?: InvestorSummary;
  beneficiary?: { uuid: string; name: string };
  quotaUuid?: string;
  amount?: string;
}

interface CreateInvestmentStoreState {
  request: (CreateInvestmentRequest & { id: number }) | null;
  open: (request?: CreateInvestmentRequest) => void;
  close: () => void;
}

export const useCreateInvestmentStore = create<CreateInvestmentStoreState>()(
  devtools(
    (set) => ({
      request: null,
      open: (request = {}) =>
        set((current) => ({ request: { ...request, id: (current.request?.id ?? 0) + 1 } })),
      close: () => set({ request: null }),
    }),
    { name: "CreateInvestmentStore" },
  ),
);
